var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    { staticClass: "i-nav", attrs: { role: "navigation" } },
    [
      _c(
        "div",
        {
          staticClass: "i-nav-mobile-inner",
          class: { "i-nav-mobile-inner-active": _vm.isMobileMenuActive },
        },
        [
          _c(
            "div",
            { staticClass: "nav-list" },
            [
              _c("i-repeat", {
                staticClass: "i-nav-mobile-inner-icon-wrapper",
                attrs: {
                  items: _vm.isClickAvatar
                    ? _vm.avatarList
                    : _vm.navMobileInnerList,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "div",
                          {
                            class: `menu-item-area ${item.customClass || ""}`,
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return item.method.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "i-repeat-a",
                                class: {
                                  "icon-disabled": item.disabled,
                                },
                                attrs: {
                                  role: "button",
                                  "aria-label": item.caption,
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "i-repeat-icon-wrapper" },
                                  [
                                    _c("svg-icon", {
                                      class: `i-repeat-icon icon-${item.name}${
                                        item.isActive ? " icon-active" : ""
                                      }`,
                                      attrs: {
                                        name: item.name,
                                        color: "#000000",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "i-repeat-text",
                                    staticStyle: { color: "#000" },
                                  },
                                  [_vm._v(_vm._s(item.caption))]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.showPoweredBy && !_vm.isUiMode
            ? _c("ul", { staticClass: "i-nav-policy" }, [
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _vm._m(2),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "i-nav-pc" },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.currentBuilding.homeButtonEnable,
                  expression: "currentBuilding.homeButtonEnable",
                },
                {
                  name: "tooltip",
                  rawName: "v-tooltip.bottom",
                  value: {
                    content: _vm.isFloatMenuActive
                      ? ""
                      : _vm.$t("returnToFirstPanorama"),
                  },
                  expression:
                    "{\n        content: isFloatMenuActive ? '' : $t('returnToFirstPanorama'),\n      }",
                  modifiers: { bottom: true },
                },
              ],
              staticClass: "i-nav-pc-home-wrapper",
              on: { click: _vm.homeIconClick },
            },
            [_c("i", { staticClass: "isif isif-home home-icon" })]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isHideMenu,
                  expression: "!isHideMenu",
                },
                {
                  name: "tooltip",
                  rawName: "v-tooltip.bottom",
                  value: {
                    content: _vm.isFloatMenuActive
                      ? ""
                      : _vm.$t("otherFunctions"),
                  },
                  expression:
                    "{\n        content: isFloatMenuActive ? '' : $t('otherFunctions'),\n      }",
                  modifiers: { bottom: true },
                },
              ],
              staticClass: "i-nav-pc-expand-wrapper expand-btn",
              class: _vm.isFloatMenuActive ? "active" : "",
              on: { click: _vm.showFloatMenu },
            },
            [_c("i", { staticClass: "isif isif-expand expand-icon" })]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isFloatMenuActive,
                  expression: "isFloatMenuActive",
                },
              ],
              staticClass: "i-nav-pc-icon-wrapper",
            },
            _vm._l(_vm.navPcGruopedList, function (group, index) {
              return _c(
                "div",
                { key: index },
                [
                  _c("i-repeat", {
                    attrs: { items: group },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                {
                                  class: `menu-item-area i-nav-pc-li-inner ${
                                    item.customClass || ""
                                  }`,
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return item.method.apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "i-repeat-a i-repeat-a-horizontal",
                                      class: {
                                        "icon-disabled": item.disabled,
                                      },
                                      attrs: {
                                        role: "button",
                                        "aria-label": item.caption,
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "i-repeat-icon-wrapper",
                                          style: item.iconWrapperStyle,
                                        },
                                        [
                                          _c("svg-icon", {
                                            class: `i-repeat-icon icon-${
                                              item.name
                                            }${
                                              item.isActive
                                                ? " icon-active"
                                                : ""
                                            }`,
                                            attrs: {
                                              name: item.name,
                                              color: _vm.icon[item.name].color,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "item-caption" }, [
                                    _vm._v(_vm._s(item.caption)),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                  _vm._v(" "),
                  index !== _vm.navPcGruopedList.length - 1
                    ? _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: group.length,
                            expression: "group.length",
                          },
                        ],
                        staticClass: "menu-group-last-item-line",
                      })
                    : _vm._e(),
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("modal-profile", { ref: "ModalProfile" }),
          _vm._v(" "),
          _c("modal-booking", {
            ref: "ModalBooking",
            attrs: {
              company: _vm.profile.companyDisplayName || _vm.$t("None"),
              calendar: _vm.currentBuilding.calendar,
              bookings: _vm.currentBuilding.bookings,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showChatBox
        ? _c("chat-box", { attrs: { "custom-class": "chat-box" } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c(
        "a",
        {
          staticClass: "footer-text",
          attrs: {
            href: "https://www.istaging.com/legal/terms_of_service",
            target: "_blank",
          },
        },
        [_c("span", [_vm._v("Terms of use")])]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c(
        "a",
        {
          staticClass: "footer-text",
          attrs: {
            href: "https://www.istaging.com/legal/privacy_policy",
            target: "_blank",
          },
        },
        [_c("span", [_vm._v("Privacy policy")])]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c(
        "a",
        {
          staticClass: "footer-text",
          attrs: { href: "https://www.istaging.com", target: "_blank" },
        },
        [_c("span", [_vm._v("Powered by iStaging")])]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }